<template>
  <v-container grid-list-md>
      <v-layout row v-for="modulo in modulos" :key="modulo.id">
        <v-flex lg12>
          <v-layout row>
            <div class="title font-weight-bold">Modulos o servicios disponibles en : {{modulo.titulo}}</div>
          </v-layout>
          <v-layout row wrap>
            <v-flex v-for="hijo in modulo.modulosHijos" :key="hijo.id"  xs12 sm6 md4 lg3 class="d-flex">
              <v-card
                width="100%"
                class="elevation-24"
                :to="{ name: 'RedirectModule', params: { id: hijo.id }}"
              >               
                  <v-img :src="doc_url+hijo.urlLogo" aspect-ratio="2"></v-img>
                <v-card-text>
                  <h4 class="title font-weight-bold mb-3">{{hijo.titulo}}</h4>
                  <p>{{hijo.descripcion}}</p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <br>
        </v-flex>
      </v-layout>
    
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      modulos: [],
      doc_url:this.$docUrl
    };
  },
  mounted() {
    this.modulos = this.$store.state.modulos;
  }
};
</script>